// Frans (fr-FR), ridesApp: zelfde vorm als ridesApp.nl.ts. {role} is een werkwoord (dépose,
// récupère) in "Qui {role} le {date} ?" en een infinitief (Déposer, Récupérer) in de meldingen.
export const appRidesFr = {
    unknown: 'Pas encore connu',
    notNeeded: 'Pas besoin',
    perDay: 'Différent selon le jour',
    perDayHint: 'Par exemple {a} le lundi et {b} le jeudi.',
    perDayHintOne: 'Par exemple une autre personne le lundi que le jeudi.',
    sameEveryDay: 'La même personne à chaque fois',
    day: 'Jour',
    roleOnDay: '{role} le {day}',
    change: 'Modifier',
    close: 'Fini',
    droppedDays: {
        one: 'Conducteur retiré pour {days} : ce jour ne fait plus partie de la répétition.',
        other: 'Conducteurs retirés pour {days} : ces jours ne font plus partie de la répétition.',
    },
    cantDrive: 'Pas possible ? Quelqu’un d’autre',
    iCant: 'Je ne peux pas, laisser ouvert',
    someoneElse: 'Quelqu’un d’autre conduit',
    whoInstead: 'Qui {role} le {date} ?',
    whoInsteadHint: 'Seulement cette fois. Les autres fois restent comme elles sont.',
    onlyThisTime: 'Seulement cette fois',
    usually: 'normalement {name}',
    usuallyNobody: 'normalement personne',
    everyWeekday: 'chaque {day}',
    backToUsual: 'Revenir à la normale',
    takenOver: '{name} {role} cette fois',
    nobodyNow: '{role} : sur « Qui conduit ? » cette fois. Les autres le voient.',
    backDone: '{role} : de nouveau comme d’habitude',
    verbDropoff: 'dépose',
    verbPickup: 'récupère',
};
//# sourceMappingURL=ridesApp.fr.js.map